<template>
  <router-view />
</template>

<script>
export default {
  name: "work-allocation-matrix",
  title() {
    return this.$t('components.appsidebar.work_allocation_matrix');
  },
};
</script>

<style lang="scss" scoped>
</style>
